import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/account/transfer_/start')({
  component: () => <Navigate to="/account/transfer" replace />,
});
